import React from 'react';
import styled from '@emotion/styled';
import { colors } from 'src/theme';
import { RadioOptionWithDescription } from 'src/components/inputs/radioOptionWithDescription.input';

export interface RadioOptionGroupOption {
  value: string;
  /** Display as option heading; use `label` as alias if preferred */
  title?: string;
  label?: string;
  description?: string;
  isPopular?: boolean;
}

export interface RadioOptionGroupProps {
  options: RadioOptionGroupOption[];
  value?: string;
  onChange: (value: string) => void;
  label?: string;
  error?: string;
  disabled?: boolean;
  className?: string;
}

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '100%',
});

const GroupLabel = styled.label({
  fontFamily: "'Red Hat Text', sans-serif",
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  color: colors.text1,
});

const ValidationError = styled.div({
  fontSize: '14px',
  color: colors.error1,
  paddingTop: '4px',
});

export const RadioOptionGroup: React.FC<RadioOptionGroupProps> = ({
  options,
  value,
  onChange,
  label,
  error,
  disabled = false,
  className,
}) => (
  <Container className={className}>
    {label != null && label !== '' && <GroupLabel>{label}</GroupLabel>}
    {options.map((option) => (
      <RadioOptionWithDescription
        key={option.value}
        value={option.value}
        title={option.title ?? option.label ?? ''}
        description={option.description ?? ''}
        selected={value === option.value}
        onChange={onChange}
        isPopular={option.isPopular ?? false}
        disabled={disabled}
      />
    ))}
    {error != null && error !== '' && <ValidationError>{error}</ValidationError>}
  </Container>
);
